module.exports = __webpack_public_path__ + "static/media/angry-face.b948d219.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Players/angry-face.svg
// module id = 192
// module chunks = 0